"use client";

import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { Map, X } from "lucide-react";

export function MapToggle({ showMap }: { showMap: boolean }) {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  function toggle() {
    const params = new URLSearchParams(searchParams.toString());
    if (showMap) {
      params.delete("map");
    } else {
      params.set("map", "true");
    }
    router.push(`${pathname}?${params.toString()}`, { scroll: false });
  }

  return (
    <button
      onClick={toggle}
      className="inline-flex items-center gap-2 px-4 py-3 text-sm font-bold rounded-sm border transition-all cursor-pointer bg-white border-stone/30 text-forest hover:bg-sage-pale"
      aria-label={showMap ? "Hide map" : "Show map"}
    >
      {showMap ? (
        <>
          <X className="w-4 h-4" />
          Hide Map
        </>
      ) : (
        <>
          <Map className="w-4 h-4" />
          Show Map
        </>
      )}
    </button>
  );
}
